import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared';
import { TranslateModule } from '@ngx-translate/core';
import { ClipboardModule } from 'ngx-clipboard';
import { AlertsComponent } from './alerts/alerts.component';
import { ApiKeysComponent } from './api-keys/api-keys.component';
import { EnvironmentAdminsComponent } from './environment-admins/environment-admins.component';
import { EnvironmentsComponent } from './environments/environments.component';
import { FileTransfersAlertsComponent } from './file-transfers-alerts/file-transfers-alerts.component';
import { FileTransfersApiKeysComponent } from './file-transfers-api-keys/file-transfers-api-keys.component';
import { FileTransfersArchivedFilesAccessesComponent } from './file-transfers-archived-files-accesses/file-transfers-archived-files-accesses.component';
import { FileTransfersRenamingParametersComponent } from './file-transfers-renaming-parameters/file-transfers-renaming-parameters.component';
import { FileTransfersComponent } from './file-transfers/file-transfers.component';
import { GlobalAdminsComponent } from './global-admins/global-admins.component';
import { HomeAckWaitingListComponent } from './home-ack-waiting-list/home-ack-waiting-list.component';
import { HomeFileTransfersExecutionComponent } from './home-file-transfers-execution/home-file-transfers-execution.component';
import { HomeHistoryFileTransfersComponent } from './home-history-file-transfers/home-history-file-transfers.component';
import { HomeLocalAgentsManagementComponent } from './home-local-agents-management/home-local-agents-management.component';
import { HomeStatisticsComponent } from './home-statistics/home-statistics.component';
import { HomeComponent } from './home/home.component';
import { LocalAgentsCommandsComponent } from './local-agents-commands/local-agents-commands.component';
import { LocalAgentsExecutionTriggersComponent } from './local-agents-execution-triggers/local-agents-execution-triggers.component';
import { LocalAgentsMaintenancesComponent } from './local-agents-maintenances/local-agents-maintenances.component';
import { LocalAgentsComponent } from './local-agents/local-agents.component';
import { LogsComponent } from './logs/logs.component';
import { PgpKeysComponent } from './pgp-keys/pgp-keys.component';
import { ProfileComponent } from './profile/profile.component';

import {
    DxAutocompleteModule,
    DxBoxModule,
    DxButtonModule,
    DxChartModule,
    DxCheckBoxModule,
    DxContextMenuModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDateRangeBoxModule,
    DxDropDownBoxModule,
    DxFileUploaderModule,
    DxFilterBuilderModule,
    DxFormModule,
    DxListModule,
    DxLoadPanelModule,
    DxPieChartModule,
    DxPopupModule,
    DxProgressBarModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxSwitchModule,
    DxTabPanelModule,
    DxTabsModule,
    DxTagBoxModule,
    DxTemplateModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxTooltipModule,
    DxTreeListModule,
    DxTreeViewModule,
    DxValidationGroupModule,
    DxValidationSummaryModule,
    DxValidatorModule
} from 'devextreme-angular';
import { RemotePlatformsComponent } from './remote-platforms/remote-platforms.component';
import { FileTransferComponent } from './file-transfer/file-transfer.component';

@NgModule({
    imports: [
        ClipboardModule,
        DxAutocompleteModule,
        DxBoxModule,
        DxButtonModule,
        DxCheckBoxModule,
        DxDataGridModule,
        DxDateBoxModule,
        DxDropDownBoxModule,
        DxFilterBuilderModule,
        DxFormModule,
        DxListModule,
        DxLoadPanelModule,
        DxChartModule,
        DxPieChartModule,
        DxPopupModule,
        DxScrollViewModule,
        DxSelectBoxModule,
        DxSwitchModule,
        DxTabPanelModule,
        DxTagBoxModule,
        DxTemplateModule,
        DxTextAreaModule,
        DxTextBoxModule,
        DxTooltipModule,
        DxTreeListModule,
        DxTreeViewModule,
        DxValidationGroupModule,
        DxValidationSummaryModule,
        DxValidatorModule,
        FormsModule,
        SharedModule,
        TranslateModule,
        CommonModule,
        DxContextMenuModule,
        DxFileUploaderModule,
        DxTabsModule,
        DxDateRangeBoxModule,
        DxProgressBarModule
    ],
    declarations: [
        AlertsComponent,
        ApiKeysComponent,
        EnvironmentAdminsComponent,
        EnvironmentsComponent,
        FileTransferComponent,
        FileTransfersAlertsComponent,
        FileTransfersApiKeysComponent,
        FileTransfersArchivedFilesAccessesComponent,
        FileTransfersComponent,
        FileTransfersRenamingParametersComponent,
        GlobalAdminsComponent,
        HomeAckWaitingListComponent,
        HomeComponent,
        HomeFileTransfersExecutionComponent,
        HomeHistoryFileTransfersComponent,
        HomeLocalAgentsManagementComponent,
        HomeStatisticsComponent,
        LocalAgentsComponent,
        LocalAgentsCommandsComponent,
        LocalAgentsExecutionTriggersComponent,
        LocalAgentsMaintenancesComponent,
        LogsComponent,
        PgpKeysComponent,
        ProfileComponent,
        RemotePlatformsComponent
    ],
    exports: [
        HomeComponent,
        GlobalAdminsComponent,
    ],
})
export class FeaturesModule { }
